import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

import { selectIsUserAuthenticated } from '../Auth/selector';

const StyledButton = styled(({ isActive, ...props }) => <Button {...props} />)(
  props => ({
    position: 'relative',
    '&:hover': {
      backgroundColor: props.isActive ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      height: '3px',
      width: '100%',
      backgroundColor: props.isActive ? '#1976d2' : 'transparent',
    }
  }),
);

const NavLink = (props) => {
  const location = useLocation();
  const { children, path, isActive } = props;

  return (
    <StyledButton color="inherit" isActive={isActive || location.pathname === path}>
      <Link href={path} color="inherit" underline="none">{children}</Link>
    </StyledButton>
  );
};

const Menu = () => {
  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);

  return (
    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
      {isUserAuthenticated !== false ? (
        <>
          <NavLink isActive path="/dashboard">Dashboard</NavLink>
          <NavLink path="/logout">Logout</NavLink>
        </>
      ) : (
        <>
          <NavLink path="/login">Login</NavLink>
          <NavLink path="/signup">Sign Up</NavLink>
        </>
      )}
    </Box>
  );
};

export default Menu;
